import script from "./OrderOutOfStock.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderOutOfStock.vue?vue&type=script&setup=true&lang=ts"

import "./OrderOutOfStock.vue?vue&type=style&index=0&id=7b2060ac&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2060ac"]])

export default __exports__